import { FormQuestionType } from '@televet/shared-types';
import React, { ReactElement } from 'react';
import Prompt from '../Prompt';
import { IFromDraftCommonProps } from '../Question';
import QuestionHeader from '../QuestionHeader';
import RequiredSelector from './RequiredSelector';

const Date = ({ index, prompt, isRequired, lastIndex }: IFromDraftCommonProps): ReactElement => {
  return (
    <>
      <QuestionHeader index={index} questionType={FormQuestionType.DateInput} lastIndex={lastIndex} />
      <Prompt index={index} prompt={prompt} />
      <RequiredSelector index={index} isRequired={isRequired} />
    </>
  );
};

export default Date;
